// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header component: logo, search form, date display */

.header {
  height: fit-content;
  padding: 0;
}

.header__branding {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.header__branding-text {
  max-width: 200px;
  line-height: 1;
}

.header__title {
  margin: 0;
  font-size: 1.7rem;
}

.header__slogan {
  /* eslint-disable-next-line css/no-invalid-properties */
  font-family: var(--font-jakarta);
  font-size: 0.61rem;
  font-weight: 600;
}

.header__logo {
  width: 75px;
  height: 75px;
}

/* Container for the form */
.header__form {
  display: flex;
  align-items: center;
  border-radius: 25px; /* Component-specific shape */
  width: 100%;
  max-width: 35%;
  padding: 5px;
}

.header__controls {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;
  min-width: 0;
}

/* Specific hover behavior for the form */
.header__form:focus-within {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

/* The Label/Input Wrapper */
.header__form label {
  flex: 1;
  display: flex;
}

/* The actual text input */
.header__input {
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  /* eslint-disable-next-line css/font-family-fallbacks */
  font-family: inherit;
  font-size: 0.95rem;
  width: 100%;
}

/* Placeholder styling */
.header__input::placeholder {
  color: rgba(255, 255, 255, 0.4);
  font-weight: 300;
}

.header__input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px transparent inset;
  -webkit-text-fill-color: #fff;
  transition: background-color 9999s ease-in-out 0s;
}

/* The Search btn */
.header__btn {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.header__btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.header__btn > svg {
  fill: #e3e3e3;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.header__btn:hover > svg {
  opacity: 1;
}

.header__date {
  font-weight: 500;
  min-width: fit-content;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  padding: 0 0.9rem;
  border-radius: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/header.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,6BAA6B;EAClD,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* Header component: logo, search form, date display */\n\n.header {\n  height: fit-content;\n  padding: 0;\n}\n\n.header__branding {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.header__branding-text {\n  max-width: 200px;\n  line-height: 1;\n}\n\n.header__title {\n  margin: 0;\n  font-size: 1.7rem;\n}\n\n.header__slogan {\n  /* eslint-disable-next-line css/no-invalid-properties */\n  font-family: var(--font-jakarta);\n  font-size: 0.61rem;\n  font-weight: 600;\n}\n\n.header__logo {\n  width: 75px;\n  height: 75px;\n}\n\n/* Container for the form */\n.header__form {\n  display: flex;\n  align-items: center;\n  border-radius: 25px; /* Component-specific shape */\n  width: 100%;\n  max-width: 35%;\n  padding: 5px;\n}\n\n.header__controls {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 10px;\n  min-width: 0;\n}\n\n/* Specific hover behavior for the form */\n.header__form:focus-within {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n/* The Label/Input Wrapper */\n.header__form label {\n  flex: 1;\n  display: flex;\n}\n\n/* The actual text input */\n.header__input {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #ffffff;\n  /* eslint-disable-next-line css/font-family-fallbacks */\n  font-family: inherit;\n  font-size: 0.95rem;\n  width: 100%;\n}\n\n/* Placeholder styling */\n.header__input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 300;\n}\n\n.header__input:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px transparent inset;\n  -webkit-text-fill-color: #fff;\n  transition: background-color 9999s ease-in-out 0s;\n}\n\n/* The Search btn */\n.header__btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.header__btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.header__btn > svg {\n  fill: #e3e3e3;\n  opacity: 0.8;\n  transition: opacity 0.2s ease;\n}\n\n.header__btn:hover > svg {\n  opacity: 1;\n}\n\n.header__date {\n  font-weight: 500;\n  min-width: fit-content;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  padding: 0 0.9rem;\n  border-radius: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
